import { render } from "./InstantiateCohortModal.vue?vue&type=template&id=718b091c"
import script from "./InstantiateCohortModal.vue?vue&type=script&lang=js"
export * from "./InstantiateCohortModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__